// Radius of the earth in metres
const R = 6371e3;

// Convert Radials to Degrees
function rad2deg(radians) {
  let pi = Math.PI;
  return radians * (180/pi);
}

// Convert Degrees to Radials
function deg2rad(degrees) {
  let pi = Math.PI;
  return degrees * (pi/180);
}

export default {
  /**
   * Calculate a square bounding based on a given lat long and radius
   * 
   * @param {Int} lat Latitude to create the bounding box from
   * @param {Int} lng Longitude to create the bounding box from
   * @param {Float} rad Radius of the surrounding area to be used as the bounds
   */
  calculateBoundingBox(lat, lng, radius = 1.5) {
    if(lat && lng) {
      let rBounding = radius; // Radius of desired bound area (in KM)
  
      // first-cut bounding box (in degrees)
      let top = lat + rad2deg(rBounding/R);  // maxLat
      let bottom = lat - rad2deg(rBounding/R);     // minLat
      let right = lng + rad2deg(Math.asin(rBounding/R) / Math.cos(deg2rad(lat)));    // maxLon
      let left = lng - rad2deg(Math.asin(rBounding/R) / Math.cos(deg2rad(lat)));     // minLon
  
      // Return bounding box co-ordinates
      return { top, right, bottom, left };
    }

    return null;
  },


  /**
   * Calculate a square bounding based on a given lat long and radius
   * 
   * @param {Array<Object>} latLngArray An array of latlng objects - Ex: [{lat: 1.1, lng: 1.1}, {lat: 1.1, lng: 1.1}]
   */
  getBoundsFromLatLngArray(latLngArray) {
    let lats = latLngArray.map(function(p) { return p.lat });
    let lngs = latLngArray.map(function(p) { return p.lng });
    
    let min = {
      lat: Math.min.apply(null, lats),
      lng: Math.min.apply(null, lngs)
    }

    let max = {
      lat: Math.max.apply(null, lats),
      lng: Math.max.apply(null, lngs)
    }

    return { min, max };
  },


  /**
   * Use haversine formula to calulate the distance between two points
   * 
   * @param {Float} lat1 The latitude of the first point
   * @param {Float} lng1 The longitude of the first point
   * @param {Float} lat2 The latitude of the second point
   * @param {Float} lng2 The longitude of the second point
   * 
   * @returns {Float} The distance in M
   */
  calculateDistanceBetweenPoints(lat1, lng1, lat2, lng2) {
    let radialLat1 = deg2rad(lat1);
    let radialLat2 = deg2rad(lat2);
    let radialLatDiff = deg2rad(lat2-lat1);
    let radialLngDiff = deg2rad(lng2-lng1);
    
    // a is the square of half the chord length between the points
    let a = Math.sin(radialLatDiff/2) * Math.sin(radialLatDiff/2) +
    Math.cos(radialLat1) * Math.cos(radialLat2) *
    Math.sin(radialLngDiff/2) * Math.sin(radialLngDiff/2);
    
    // c is the angular distance in radians
    let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));

    // d is the distance in metres
    let d = R * c;

    return d;
  },

  /** Get a LatLng given a starting point, bearing, and distance
   * 
   * @param {*} distance 
   * @param {*} bearing 
   */
  calculateCoordsUsingBearingAndDistance(lat, lng, distance, bearing) {
    let δ = Number(distance) / R; // angular distance in radians
    let θ = deg2rad(Number(bearing));

    let φ1 = deg2rad(lat);
    let λ1 = deg2rad(lng);

    let sinφ1 = Math.sin(φ1), cosφ1 = Math.cos(φ1);
    let sinδ = Math.sin(δ), cosδ = Math.cos(δ);
    let sinθ = Math.sin(θ), cosθ = Math.cos(θ);

    let sinφ2 = sinφ1 *cosδ + cosφ1*sinδ*cosθ;
    let φ2 = Math.asin(sinφ2);
    let y = sinθ * sinδ * cosφ1;
    let x = cosδ - sinφ1 * sinφ2;
    let λ2 = λ1 + Math.atan2(y, x);

    return { lat: rad2deg(φ2), lng: ((rad2deg(λ2)+540)%360-180) }; // normalise to −180..+180°
  }

}